/**
 * Copyright 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Maybe, Resource } from "~/generated/graphql";
import { SidebarItem } from "~/hooks/useGetResources";
import { ColumnType, SelectionMethod } from "~/types";

type MinimalResource = Pick<Resource, "name" | "id" | "os">;

export const mapResourceToItem = (
  resource: Maybe<MinimalResource> | undefined,
  method: SelectionMethod
): SidebarItem => ({
  name: resource?.name ?? "",
  id: resource?.id ?? "",
  tag: method,
  columns: [
    {
      data: [resource?.os?.subType ?? "", resource?.os?.type ?? ""],
      type: ColumnType.os,
    },
    {
      data: [resource?.name ?? "", resource?.id ?? ""],
      type: ColumnType.text,
    },
    {
      data: [method],
      type: ColumnType.selectionMethod,
    },
  ],
});

export const mapResourceToSelectedItem = (
  resource: Maybe<MinimalResource> | undefined
): SidebarItem => mapResourceToItem(resource, SelectionMethod.manual);

export const mapResourcesToItems = (
  resources: Array<Maybe<MinimalResource>> | null | undefined,
  method: SelectionMethod
) => (resources ?? []).map((r) => mapResourceToItem(r, method));
